/* istanbul ignore next */
const ACTIONS = {
    VERIFY_PM_ELIGIBILITY: 'VERIFY_PM_ELIGIBILITY',
    CONFIRMATION_SERVICE_ERROR: 'CONFIRMATION_SERVICE_ERROR',
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    updateOnboardingStatus() {
        return {
            type: ACTIONS.VERIFY_PM_ELIGIBILITY,
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.CONFIRMATION_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};